module.exports = __webpack_public_path__ + "img/banner.61ca42c4.jpg";